export default class Tabs {

    static initializeEvents() {
        Array
            .from(document.querySelectorAll('.tabs .tabs-list .tabs-tab'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    const tabIdentifier = event.target.id;
                    const tabWrapper = event.target.parentNode.parentNode.parentNode;

                    // On retire l'état "actif" du bouton et de l'onglet actuellement ouverts
                    tabWrapper.querySelectorAll('.tabs-tab.active, .tabs-panel.active').forEach(element => {
                        element.classList.remove('active');

                        if (element.classList.contains('tabs-panel')) {
                            element.setAttribute('tabindex', '-1');
                        } else {
                            element.setAttribute('aria-selected', 'false');
                        }
                    });

                    // On ajoute l'état "actif" sur le bouton sélectionné
                    event.target.classList.add('active');
                    event.target.setAttribute('aria-selected', 'true');

                    // On ajoute l'état "actif" sur l'onglet sélectionné
                    const tabContent = tabWrapper.querySelector('.tabs .tabs-panel[aria-labelledby="' + tabIdentifier + '"]');
                    if (tabContent) {
                        tabContent.classList.add('active');
                        tabContent.removeAttribute('tabindex');
                    }
                });
            });
    }

}